import React from "react";
import { FormattedMessage } from "react-intl";
import { NavigationGroup, NavigationItem } from '@ktr/ktr-materialui-react';

const navBarItems : Array<NavigationItem> = [
  {
    Name: <FormattedMessage id="app.nav.clampexassistant"/>,
    Url: "https://otools.ktr.com/clampexassistant"
  },  
{
  Name: <FormattedMessage id="app.navProdukteAntriebstechnik"/>,
  Url: "https://otools.ktr.com/otools/index.html?inittab=1"
},
{
  Name: <FormattedMessage id="app.navProdukteHydr"/>,
  Url: "https://otools.ktr.com/otools/index.html?inittab=2"
},
{
  Name: <FormattedMessage id="app.navProdukteKuehl"/>,
  Url: "https://otools.ktr.com/otools/index.html?inittab=3"
}];


const navBarItemsAboutKTR : Array<NavigationItem> = [{
  Name: <FormattedMessage id="app.navUeberKTRHomp"/>,
  Url: "https://ktr.com"
},
{
  Name: <FormattedMessage id="app.navUeberKTRKontakt"/>,
  Url: "https://www.ktr.com/en/contact"
}];

  const navigationButtonsData : Array<NavigationGroup> = [{
  Name: <FormattedMessage id="app.nav.tools"/>,
  NavBarItems: navBarItems
}, 
{
  Name: <FormattedMessage id="app.navUeberKTR"/>,
  NavBarItems: navBarItemsAboutKTR
}]

const navigationButtons: Array<NavigationGroup> = navigationButtonsData;
export default navigationButtons;